import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import i18n from 'i18n-react';

const FreeHotel = (props) => {
  const {
    id,
    bgImage,
    flyToMarker,
    hotelInfo,
    hotelName,
    location,
    phoneNumber,
    address,
    category,
    other,
    item,
  } = props;
  return (
    <div
      className="freeDiv"
      id={id}
      style={{
        backgroundImage: `url(${bgImage})`,
      }}
    >
      <div className="freeInfoDiv" onClick={hotelInfo}>
        <span className="freeHotelName">{hotelName}</span> <br />
        <br />
        {/* <span className='freeHotelCity'>{category}</span> <br />
        <br /> */}
        <span className="freeHotelCity">{location}, {item.city}</span> <br />
        <span className="freeHotelPhone">{item.web_url}</span> <br /><br />
        {/* <span className='freeHotelPhone'>{phoneNumber}</span> <br />
        <span className='freeHotelPhone'>{other.email}</span> <br /> */}
        <span className="moreInfo">{i18n.translate('directory.view')}</span>
        {/* <br /> */}
      </div>
      <div className="iconDiv" onClick={flyToMarker}>
        <span
          className="fa-layers fa-fw fa-2x markerCircle"
        >
          <FontAwesomeIcon icon={['fas', 'circle']} className="circle" />
          <FontAwesomeIcon
            icon={['fas', 'map-marker-alt']}
            className="marker"
          />
        </span>
      </div>
    </div>
  );
};

FreeHotel.propTypes = {
  id: PropTypes.string,
  bgImage: PropTypes.string,
  propertyName: PropTypes.string,
  flyToMarker: PropTypes.func,
  hotelInfo: PropTypes.func,
  hotelName: PropTypes.string,
  location: PropTypes.string,
  phoneNumber: PropTypes.string,
  address: PropTypes.string,
  category: PropTypes.string,
};

FreeHotel.defaultProps = {
  id: '',
  bgImage: '',
  propertyName: '',
  flyToMarker: () => {},
  hotelInfo: () => {},
  hotelName: '',
  location: '',
  phoneNumber: '',
  address: '',
  category: '',
};

export default FreeHotel;
